var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-toolbar-wrapper" }, [
    _c("div", { staticClass: "board-view-tabs" }, [
      _c("div", { staticClass: "tabs-container" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            {
              staticClass: "tab",
              class: { active: _vm.currentBoardView === "table" },
              on: {
                click: function ($event) {
                  return _vm.changeBoardView("table")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("grid_on")]),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("tables.table")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab",
              class: { active: _vm.currentBoardView === "kanban" },
              on: {
                click: function ($event) {
                  return _vm.changeBoardView("kanban")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("view_kanban"),
              ]),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("tables.kanban")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab",
              class: { active: _vm.currentBoardView === "calendar" },
              on: {
                click: function ($event) {
                  return _vm.changeBoardView("calendar")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("event")]),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("tables.calendar")) +
                  "\n                "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.moduleMode && _vm.selectedModule
          ? _c("div", { staticClass: "right" }, [
              _c("div", { staticClass: "module-title-wrapper" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(_vm.selectedModule.icon || "extension")),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.selectedModule.displayName)),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-toolbar" },
      [
        _c(
          "div",
          { staticClass: "left-actions" },
          [
            _c(
              "a-popover",
              {
                attrs: {
                  placement: "bottomLeft",
                  trigger: "click",
                  overlayClassName: "view-switcher-popover zero-padding",
                },
                model: {
                  value: _vm.viewSwitcherVisible,
                  callback: function ($$v) {
                    _vm.viewSwitcherVisible = $$v
                  },
                  expression: "viewSwitcherVisible",
                },
              },
              [
                _c(
                  "template",
                  { slot: "content" },
                  [
                    _c("ViewSwitcher", {
                      attrs: { table: _vm.table },
                      on: {
                        "show-view": _vm.onShowView,
                        "edit-view": _vm.onEditView,
                        "create-new-view": _vm.onCreateNewView,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("SupsisButton", { attrs: { primary: "" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.currentView
                          ? _vm.currentView.name
                          : _vm.$t("tables.mainTable") +
                              " - (" +
                              _vm.table.name +
                              ")"
                      ) +
                      "\n                    "
                  ),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("arrow_drop_down"),
                  ]),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "a-popover",
              {
                attrs: {
                  placement: "bottomLeft",
                  trigger: "click",
                  overlayClassName: "table-filter-popover",
                },
                model: {
                  value: _vm.filterVisible,
                  callback: function ($$v) {
                    _vm.filterVisible = $$v
                  },
                  expression: "filterVisible",
                },
              },
              [
                _c(
                  "template",
                  { slot: "content" },
                  [
                    _c("TableFilter", {
                      attrs: { fields: _vm.fields, value: _vm.filters },
                      on: { input: _vm.onFilterChange },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: {
                      classNames:
                        "" + (_vm.filters.length > 0 ? "active-filters" : ""),
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("filter_alt"),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("tables.filter")) +
                        "\n                    "
                    ),
                    _vm.filters.length > 0
                      ? _c("span", { staticClass: "filter-count" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.filters.length) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.length
                      ? _c(
                          "i",
                          {
                            staticClass: "material-icons clear-filters",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.clearFilters.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("close")]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            !_vm.moduleMode
              ? _c(
                  "SupsisButton",
                  {
                    attrs: {
                      classNames:
                        "" +
                        (_vm.hiddenFields.length > 0 ? "active-filters" : ""),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("show-hide-fields")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("visibility_off"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tables.hideFields")) +
                        "\n                "
                    ),
                    _vm.hiddenFields.length > 0
                      ? _c("span", { staticClass: "filter-count" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.hiddenFields.length) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hiddenFields.length > 0
                      ? _c(
                          "i",
                          {
                            staticClass: "material-icons clear-filters",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.$emit("clear-hidden-fields")
                              },
                            },
                          },
                          [_vm._v("close")]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a-popover",
              {
                attrs: {
                  placement: "bottomRight",
                  trigger: "click",
                  overlayClassName: "table-group-popover",
                },
                model: {
                  value: _vm.groupPopoverVisible,
                  callback: function ($$v) {
                    _vm.groupPopoverVisible = $$v
                  },
                  expression: "groupPopoverVisible",
                },
              },
              [
                _c(
                  "template",
                  { slot: "content" },
                  [
                    _c("TableGroup", {
                      attrs: {
                        fields: _vm.fields,
                        "group-value": _vm.groupValue,
                      },
                      on: { "update-group": _vm.onUpdateGroup },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: {
                      classNames:
                        "" + (_vm.groupValue.fieldId ? "active-filters" : ""),
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("category"),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.group")) +
                        "\n                    "
                    ),
                    _vm.groupValue.fieldId
                      ? _c("span", { staticClass: "filter-count" }, [
                          _vm._v(" 1 "),
                        ])
                      : _vm._e(),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "a-popover",
              {
                attrs: {
                  placement: "bottomRight",
                  trigger: "click",
                  overlayClassName: "table-color-popover",
                },
                model: {
                  value: _vm.colorPopoverVisible,
                  callback: function ($$v) {
                    _vm.colorPopoverVisible = $$v
                  },
                  expression: "colorPopoverVisible",
                },
              },
              [
                _c(
                  "template",
                  { slot: "content" },
                  [
                    _c("TableColorFilter", {
                      attrs: {
                        fields: _vm.fields,
                        "color-conditions": _vm.colorConditions,
                      },
                      on: {
                        "update-color-conditions": _vm.onUpdateColorConditions,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: {
                      classNames:
                        "" +
                        (_vm.colorConditions.length > 0
                          ? "active-filters"
                          : ""),
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("color_lens"),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("tables.conditionalColor")) +
                        "\n                    "
                    ),
                    _vm.colorConditions.length > 0
                      ? _c("span", { staticClass: "filter-count" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.colorConditions.length) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            !_vm.moduleMode
              ? _c(
                  "SupsisButton",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$feature.beforeCreateTableView(
                          _vm.openCreateViewModal,
                          _vm.table.totalViews
                        )
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("save"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("tables.saveAsView")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right-actions" },
          [
            _c(
              "div",
              {
                staticClass: "search-bar",
                class: { expanded: _vm.searchExpanded || _vm.searchQuery },
                on: {
                  click: function ($event) {
                    _vm.searchExpanded = true
                  },
                },
              },
              [
                _c("input", {
                  ref: "searchInput",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("tables.search"),
                    autofocus: "",
                  },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onSearchEnter.apply(null, arguments)
                    },
                    focus: function ($event) {
                      _vm.searchExpanded = true
                    },
                    blur: function ($event) {
                      _vm.searchExpanded = false
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.searchExpanded = true
                      },
                    },
                  },
                  [_vm._v("search")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { primary: "" },
                on: { click: _vm.openCreateRecordModal },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.createRecord")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.moduleMode
              ? _c(
                  "a-popover",
                  { attrs: { trigger: "click", placement: "bottomRight" } },
                  [
                    _c("template", { slot: "content" }, [
                      _c("div", { staticClass: "action-menu" }, [
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("runWebhookAutomation")
                              },
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: { color: "#1890ff" },
                              },
                              [_vm._v("webhook")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("tables.runWebhookAutomation")) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("importRecords")
                              },
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: { color: "#52c41a" },
                              },
                              [_vm._v("upload_file")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("tables.importRecords")) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("downloadAllRecords")
                              },
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: { color: "#faad14" },
                              },
                              [_vm._v("download")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("tables.downloadAllRecords")) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            class: { disabled: !_vm.hasSelection },
                            on: {
                              click: function ($event) {
                                return _vm.handleAction(
                                  "downloadSelectedRecords"
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: { color: "#faad14" },
                              },
                              [_vm._v("download")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.hasSelection
                                    ? _vm.$t("tables.download") +
                                        " " +
                                        _vm.selectedRecords.length +
                                        " " +
                                        _vm.$t("message.records")
                                    : _vm.$t("tables.downloadSelectedRecords")
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            class: { disabled: !_vm.hasSelection },
                            on: {
                              click: function ($event) {
                                return _vm.handleAction("editRecords")
                              },
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: { color: "#1890ff" },
                              },
                              [_vm._v("edit")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.hasSelection
                                    ? _vm.$t("message.edit") +
                                        " " +
                                        _vm.selectedRecords.length +
                                        " " +
                                        _vm.$t("message.records")
                                    : _vm.$t("tables.editRecords")
                                ) +
                                "\n                            "
                            ),
                            _c("span", { staticClass: "shortcut" }, [
                              _c("kbd", [_vm._v("Ctrl")]),
                              _vm._v("+"),
                              _c("kbd", [_vm._v("E")]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            class: { disabled: !_vm.hasSelection },
                            on: { click: _vm.confirmDeleteRecords },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: { color: "#ff4d4f" },
                              },
                              [_vm._v("delete")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.hasSelection
                                    ? _vm.$t("message.delete") +
                                        " " +
                                        _vm.selectedRecords.length +
                                        " " +
                                        _vm.$t("message.records")
                                    : _vm.$t("tables.deleteRecords")
                                ) +
                                "\n                            "
                            ),
                            _c("span", { staticClass: "shortcut" }, [
                              _c("kbd", [_vm._v("Backspace")]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            class: { disabled: !_vm.hasSelection },
                            on: { click: _vm.confirmDuplicateRecords },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: { color: "#52c41a" },
                              },
                              [_vm._v("content_copy")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.hasSelection
                                    ? _vm.$t("message.duplicate") +
                                        " " +
                                        _vm.selectedRecords.length +
                                        " " +
                                        _vm.$t("message.records")
                                    : _vm.$t("tables.duplicateRecords")
                                ) +
                                "\n                            "
                            ),
                            _c("span", { staticClass: "shortcut" }, [
                              _c("kbd", [_vm._v("Ctrl")]),
                              _vm._v("+"),
                              _c("kbd", [_vm._v("D")]),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("SupsisButton", [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("more_horiz"),
                      ]),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showCreateViewModal
              ? _c(
                  "Modal2",
                  {
                    attrs: {
                      showFooter: false,
                      title: _vm.$t("tables.saveAsView"),
                      className: "create-view-modal keydown-prevent-modal",
                    },
                    on: { cancel: _vm.closeCreateViewModal },
                  },
                  [
                    _c("CreateViewForm", {
                      attrs: {
                        filters: _vm.filters,
                        sort: _vm.sort,
                        search: _vm.searchQuery,
                        hiddenFields: _vm.hiddenFields,
                        lockedFields: _vm.lockedFields,
                        "table-id": _vm.tableId,
                        "group-value": _vm.groupValue,
                        "color-conditions": _vm.colorConditions,
                      },
                      on: {
                        "view-created": _vm.onViewCreated,
                        cancel: _vm.closeCreateViewModal,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.showCreateRecordModal
          ? _c(
              "Modal2",
              {
                attrs: {
                  showFooter: false,
                  title: "Yeni Kayıt Oluştur",
                  className: "create-record-modal keydown-prevent-modal",
                },
                on: { cancel: _vm.closeCreateRecordModal },
              },
              [
                _c("TableCreateForm", {
                  attrs: {
                    table: _vm.table,
                    predefinedValues: _vm.predefinedValues,
                  },
                  on: { "record-created": _vm.onRecordCreated },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }